// extracted by mini-css-extract-plugin
export default {"GraphBar":"styles_GraphBar__YPOHA","name":"styles_name__z9o98","bar":"styles_bar__1mkAS","greenBar":"styles_greenBar__IkZUW","amount":"styles_amount__ovqza"};